// import "./styles.scss";

import { PanelBody, ToggleControl } from "@wordpress/components";
import { __ } from "@wordpress/i18n";

const BlockNegativeMarginsOptions = props => {
  const {
    setAttributes
  } = props;

  const {
    negativeTopMargin,
    negativeBottomMargin
  } = props.blockAttributes;

  return (
    <PanelBody
      className="negative-margins"
      title={ __("Negative Margins") }
    >
      <ToggleControl
        label={ __("Top") }
        checked={ negativeTopMargin }
        onChange={ negativeTopMargin => setAttributes({ negativeTopMargin }) }
      />

      <ToggleControl
        label={ __("Bottom") }
        checked={ negativeBottomMargin }
        onChange={ negativeBottomMargin => setAttributes({ negativeBottomMargin }) }
      />
    </PanelBody>
  )
}

export default BlockNegativeMarginsOptions;
